import styled from "styled-components";

export const Image = styled.img`
  width: ${({ width = "100%" }) => width};
  height: ${({ height = "100%" }) => height};
  object-fit: ${({ objectFit = "cover" }) => objectFit};
  object-position: ${({ objectPosition = "center" }) => objectPosition};
`;
